function setLanguage(lang) {
    if (lang === 'sl') {
        document.body.classList.add('slovenian');
        document.body.classList.remove('english');
    } else {
        document.body.classList.add('english');
        document.body.classList.remove('slovenian');
    }
}

function startSkinTest() {
    document.getElementById('skintest').classList.remove('hidden'); 
    document.getElementById('product-recommendations').classList.add('hidden'); 
}

function viewProducts() {
    document.getElementById('skintest').classList.add('hidden'); 
    document.getElementById('product-recommendations').classList.remove('hidden'); 
}
